import { useEffect, useRef, useState } from 'react';
import Barcode from 'react-barcode';

// Picks a symbology JsBarcode can actually encode the value with.
// EAN13/EAN8/UPC have strict length+checksum rules, so a requested
// format that doesn't match the value's shape (e.g. EAN13 on a
// 14-digit GTIN) silently fails to render. Falls back to CODE128,
// which can encode any digit string, whenever the requested/guessed
// format wouldn't fit the value.
const resolveFormat = (value, requestedFormat) => {
  const isDigits = typeof value === "string" && /^\d+$/.test(value);

  if (requestedFormat === "EAN13") return isDigits && value.length === 13 ? "EAN13" : "CODE128";
  if (requestedFormat === "EAN8") return isDigits && value.length === 8 ? "EAN8" : "CODE128";
  if (requestedFormat === "UPC") return isDigits && value.length === 12 ? "UPC" : "CODE128";
  if (requestedFormat) return requestedFormat;

  if (isDigits) {
    if (value.length === 13) return "EAN13";
    if (value.length === 12) return "UPC";
    if (value.length === 8) return "EAN8";
  }

  return "CODE128";
};

const BarcodeComponent = ({
  value,
  className="",
  width = 1,
  height = 30,
  fontSize = 15,
  format=""
}) => {
  const [copied, setCopied] = useState(false);
  const hideTimer = useRef(null);

  useEffect(() => () => clearTimeout(hideTimer.current), []);

  if (!value) return null;

  // react-barcode's <Barcode> only forwards id/className to the underlying <svg> — onClick and
  // style are silently dropped — so the click target has to be a wrapper around it instead.
  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setCopied(false), 1200);
    } catch {
      // clipboard write failed (e.g. no permission) — no feedback to show for it
    }
  };

  return (
    <span
      onClick={handleClick}
      title="Copier le code-barres"
      style={{ position: 'relative', display: 'inline-block', cursor: 'pointer' }}
    >
      <Barcode
        className={className}
        value={value}
        width={width}
        height={height}
        fontSize={fontSize}
        format={resolveFormat(value, format)}
      />
      <span
        style={{
          position: 'absolute', bottom: '100%', left: '50%', marginBottom: 6,
          background: 'rgba(0, 0, 0, 0.75)', color: '#fff', fontSize: 11, fontWeight: 700,
          padding: '3px 9px', borderRadius: 4, whiteSpace: 'nowrap',
          opacity: copied ? 1 : 0,
          transform: copied ? 'translate(-50%, 0)' : 'translate(-50%, 4px)',
          transition: 'opacity 0.18s ease, transform 0.18s ease',
          pointerEvents: 'none',
        }}
      >
        Copié
      </span>
    </span>
  );
};

export default BarcodeComponent;
